module.exports = __webpack_public_path__ + "static/img/adult.bd42764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adult.jpg?20181011
// module id = Mbkd
// module chunks = 1